<template>
  <div v-if="loading">
    <loading-animation-vue></loading-animation-vue>
  </div>
  <div v-else>
    <label class='sr-only' :for='`${label_name}_datepicker`'>{{ label }}</label>
    <flat-pickr class='d-none' :id='`${label_name}_datepicker`' name="date_picker" v-model='date' :config='datePickerConfig()'/>
  </div>  
</template>

<script>
  import {French} from 'flatpickr/dist/l10n/fr.js';

  export default {
    
    props: {
      input_name: { type: String },
      label_name: { type: String },
      label: { type: String },
      preset_date: {type: String},
      locale: {type: String},
      calendar_entries: {type: String}
    },
    data () {
        return {
            loading: true,
            date: new Date(),
            hasEvent: false,
        }
    },
    mounted() {
      if(this.preset_date) {
        this.date = new Date(this.preset_date)
      }
      this.loading = false;
    },
    methods: {
      datePickerConfig: function () {
        const _vm = this
        return { 
          enableTime: this.time == 'true',
          time_24hr: true,
          minuteIncrement: 1,
          inline: true,
          locale: (this.locale=='fr') ? French : 'en',
          onChange: function(selectedDates, dateStr, instance) {
            document.location =  `?date=${dateStr}`;
          },
          onDayCreate: function(dObj, dStr, fp, dayElem) {
            let entries;
            try {
              entries = JSON.parse(_vm.calendar_entries);
              if (entries){
                entries.map((entry) => {
                  if (entry.status !== "unpublished") {
                    const dateEntry = new Date(entry.date.start_date).toDateString();
                    const dateElement = dayElem.dateObj.toDateString();
                    if (dateEntry == dateElement) { 
                      dayElem.innerHTML += "<span class='calendar-event'></span>";
                    }
                  }     
                })
              }
            }
            catch(err) {
              this.error = true;  
            }   
          }
        };
      },
    }
  }
</script>
